module.exports = __webpack_public_path__ + "static/media/verify-business.8653cd28.svg";